import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { InputWidthValues } from "../../../ui/gzInput";
import { FontSizes } from "../../../types/common/types";

export const templateAiChat = document.createElement('template');

templateAiChat.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="content">
      <div class="chat-container" id="chatContainer">
        <gz-image-repo state="start" class="empty-state">
          <gz-title id="emptyStateTitle" class="image-repo-title" fontSize='${FontSizes.HEADING_4}' fontWeight="500"></gz-title>
          <gz-text id="emptyStateText" class="image-repo-text" fontSize="13" fontWeight="100"></gz-text>
        </gz-image-repo>
      </div>

      <div class="footer">
        <gz-available-items-card id="visibleAvailableItemsCard"></gz-available-items-card>

        <gz-textarea-with-suggestions
          id="chatTextarea"
          inputWidth="${InputWidthValues.FULL}"
          maxChars="2000"
        ></gz-textarea-with-suggestions>

        <gz-available-items-card id="hiddenAvailableItemsCard" class="hidden-card"></gz-available-items-card>
      </div>
    </div>

    <gz-image-repo state="error" class="error-state">
      <gz-title id="errorStateTitle" class="image-repo-title" fontSize='${FontSizes.HEADING_4}' fontWeight="500"></gz-title>
      <gz-text id="errorStateText" class="image-repo-text" fontSize="13" fontWeight="100"></gz-text>
    </gz-image-repo>

    <gz-image-repo state="empty" class="unavailable-state">
      <gz-title id="unavailableStateTitle" class="image-repo-title" fontSize='${FontSizes.HEADING_4}' fontWeight="500"></gz-title>
      <gz-text id="unavailableStateText" class="image-repo-text" fontSize="13" fontWeight="100"></gz-text>
    </gz-image-repo>
  </div>
`;
